import { useConfirmDialog } from "@moment/ui";

export const useDeleteConfirmModal = () => {
	const { confirm } = useConfirmDialog();

	const deleteConfirmation = ({
		headingTitle,
		name,
		action = "delete",
		confirmLabel = "Delete",
	}: {
		headingTitle?: string;
		name: string;
		action?: string;
		confirmLabel?: string;
	}) => {
		return confirm({
			headingTitle,
			content: (
				<>
					Are you sure you want to {action} <strong>{name}</strong>?
				</>
			),
			variant: "negative",
			confirmLabel,
		});
	};

	return { deleteConfirmation };
};
